export class AdminPermissions {
    public static readonly bypass: string = 'ui:bypass:maintenance';
}
